import { createStore } from 'vuex'

import state from './state'
import getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

import activities from './modules/activities'
import auth from './modules/auth'
import changeOrders from './modules/change-orders'
import checklists from './modules/checklists'
import clocklog from './modules/clocklog'
import emails from './modules/emails'
import companies from './modules/companies'
import contacts from './modules/contacts'
import dictionaries from './modules/dictionaries'
import fetchNotificationSettings from './modules/notification-settings'
import files from './modules/files'
import followedProjects from './modules/followed-projects'
import globalStates from './modules/global-states'
import historicalData from './modules/historical-data'
import menu from './modules/menu'
import notes from './modules/notes'
import notifications from './modules/notifications'
import permitTypes from './modules/permit-types'
import projectContacts from './modules/project-contacts'
import projects from './modules/projects'
import projectServices from './modules/project-services'
import proposals from './modules/proposals'
import reminders from './modules/reminders'
import slack from '../modules/slack/store'
import services from './modules/services'
import settings from './modules/settings'
import stats from './modules/stats'
import subscribedContacts from './modules/subscribed-contacts'
import subscribers from './modules/subscribers'
import tableSettings from './modules/table-settings'
import tableViews from './modules/table-views'
import tasks from './modules/tasks'
import teams from './modules/teams'
import timelogs from './modules/timelogs'
import users from './modules/users'
import roles from './modules/roles'
import workTypes from './modules/work-types'

const store = createStore({
    state, getters, actions, mutations,

    modules: {
        clocklog,
        emails,
        slack,
        users, roles, teams, auth,
        permitTypes,
        services,
        workTypes,
        companies,
        contacts,
        files,
        tasks,
        proposals,
        changeOrders,
        projects,
        projectContacts,
        followedProjects,
        projectServices,
        timelogs,
        notes,
        fetchNotificationSettings,
        checklists,
        subscribers,
        subscribedContacts,
        historicalData,
        reminders,
        activities,
        menu,
        settings,
        dictionaries,
        notifications,
        tableSettings,
        stats,
        globalStates,
        tableViews,
    }
})

export default store